import * as BaseApi from "./Base.api";
import { IAppVersion, ISkuAppstore, ISkuPlaystore } from "./interfaces/app.interface";

const baseUrl: string = process.env.REACT_APP_API_URL as string;

export const getCommonCodeList = async () => {
  console.log("AppApi.api:getCommonCodeList");

  const url = baseUrl + "/app/common-codes";
  const result = await BaseApi.get(url);

  if (result.errorCode) {
    alert(result.message);
    return null;
  } else {
    return result.data;
  }
};

export const getCountryCodeList = async () => {
  console.log("AppApi.api:getCommonCodeList");

  const url = "/app/country-codes";
  return BaseApi.get(url);
};

export const updateUserTerm = async (id: number, params: any) => {
  console.log("AppApi.api:updateUserTerm");

  const url = `/app/term/${id}`;
  return BaseApi.put(url, params);
};

export interface IGetAppVersionInfoResponse {
  info: IAppVersion | null;
}
export const getAppVersionInfo = async (params: any): Promise<IGetAppVersionInfoResponse> => {
    console.log("AppApi.api:getAppVersionInfo");
  
    const url = "/app/app-version";
    return BaseApi.get(url, params);
  };

//* 앱스토어 SKU 목록 조회
//  2025.08.22
//  희문
interface IGetSkuAppstoreListResponse {
  skuAppstoreList: ISkuAppstore[];
}

export const getSkuAppstoreList = async (): Promise<IGetSkuAppstoreListResponse> => {
  console.log("AppApi.api:getSkuAppstoreList");

  const url = "/app/sku-appstores";
  return BaseApi.get(url);
};

//* 플레이스토어 SKU 목록 조회
//  2025.08.22
//  희문
interface IGetSkuPlaystoreListResponse {
  skuPlaystoreList: ISkuPlaystore[];
}
export const getSkuPlaystoreList = async (): Promise<IGetSkuPlaystoreListResponse> => {
  console.log("AppApi.api:getSkuPlaystoreList");

  const url = "/app/sku-playstores";
  return BaseApi.get(url);
};